/** A 200 whose body is not the shape the screen reads is a **failed read**, not a crash and not an
 * empty answer (the sweep over every tab, `shell/screenStates.test.tsx`).
 *
 * A proxy's page, an older server or a bad deploy answers 200 with something that is not the
 * route's object. A screen that then reads `data.items.length` throws inside render and the reader
 * gets the whole screen's error boundary instead of the sentence "this could not be read" with a
 * way to ask again; one that defaults the missing list to `[]` says there is nothing, which is a
 * claim about the company made by a malformed body. Throwing from the query function hands the
 * shared failure treatment (`Loaded` / `ReadFailed` / a dashboard `Tile`) exactly what it already
 * knows how to draw.
 *
 * Check only what the screen dereferences without a guard: this is not a schema validator.
 */
export function requireShape(ok: boolean, what: string): void {
  if (!ok) throw new Error(`${what} came back in a shape this screen cannot read.`);
}
